import PropTypes from 'prop-types';

const OPERATEURS = ['AND', 'OR'];

const OPERATEUR_LABEL_BY_ID = {
  AND: 'ET',
  OR: 'OU',
};

const BlocOperateur = ({ operateur, onChange }) => (
  <select
    className="bloc-thematique-operateur"
    defaultValue={operateur}
    onChange={(event) => onChange(event.target.value)}
  >
    {OPERATEURS.map((id) => (
      <option value={id} key={id}>
        {OPERATEUR_LABEL_BY_ID[id]}
      </option>
    ))}
  </select>
);
BlocOperateur.propTypes = {
  operateur: PropTypes.oneOf(Object.keys(OPERATEUR_LABEL_BY_ID)).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default BlocOperateur;
